const theme = {
  colors: {
    blue: '#0E1162',
    background: '#F6F9F4',
    green: '#28A334',
  },
};

export default theme;